
























import { snakeCase } from 'lodash'
import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../../../Mixins/ModelSetter'
import { SelectOption } from '../../../../../logic/types'
import { UseFields } from '../../../../Pi'
import {  UtmSource } from '../../types'
import IncludeExcludeConditionMode from '../components/IncludeExcludeConditionMode.vue'
import { UtmCondition } from '../types';

@Component({
  components: {
    IncludeExcludeConditionMode
  },
  data() {
    return {
      snakeCase
    }
  }
})
export default class DistributionUtmCondition extends Mixins(UseFields, ModelSetter) {
  @VModel({ type: Object, required: true }) condition!: UtmCondition

  @Prop({ type: Array, required: true, default: () => [] }) utmSources!: Array<UtmSource>

  @Prop({ type: Boolean, default: false }) disabled!: boolean

  utmSourcesOptions: Array<SelectOption> = []

  selectedValues: Array<number> | null = []

  onSelectChange(values:Array<SelectOption>):void {
    this.condition.values = values.map(option => option.value as number)
  }

  setUtmSourcesOptions():void {
    this.utmSourcesOptions = this.utmSources
      .map(utm => ({
        label: utm.value,
        value: utm.id
      }))
  }

  created(): void {
    if (this.utmSources.length) {
      this.setUtmSourcesOptions()
    }

    this.selectedValues = this.condition.values === null ? [] : this.condition.values
  }
}
